import { Button, Modal } from 'antd';
import '../assets/css/calendar-colours-modal.css';
import bookingKey from '../assets/images/BookingKey.png';
import React from 'react';

export default function SwimKeyModal({ visible, onClose }) {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      width={'min(95%, 40rem)'}
      title={null}
      footer={null}
      closable={false}
      maskClosable
      centered
    >
      <img
        src={bookingKey}
        alt={'Legend for booking chart colours'}
        className={'w-full mg-auto-lr display-block mg-bottom-20'}
      />
      <Button
        className={'w-full sb-blue-bg br10 white pd-8 h-fit gSemiBold fs-18'}
        onClick={onClose}
      >
        Close
      </Button>
    </Modal>
  );
}
